import { DecimalPipe, Time } from "@angular/common";


export interface IReviewListViewModel {
  requestNo: string;
  old_Ref_Id : string;
  discipline: string;
  request_Status: string;
  created_By: string;
  created_On: Date;
  comments_Status: string;
  response_Status: string;
  date : Date;
  time_From :Time
  time_To :Time
  doc_Location : string;
  status_Update : string;
  ds_code:number
  approved_by: string;
  approved_on : Date;
  is_approve : boolean;
  peer_review_type : string;
  scope_of_review : string;
  impact_status : string;
  // Responded_By: string;
  // Responded_On: Date;
}

export interface IApproveReviewViewModel {
  requestNo: string;
  created_By: string;
  created_On: Date;
  scheduled_On: Date;
  scheduled_From: Time;
  scheduled_Upto: Time;
  document_Location: string;
  status: string;
}
export interface IApproveInputModel {
  strDocNumber: string;
  dtmScheduledOn: Date;
  tmScheduledFrom: Time;
  tmScheduledUpto: Time;
  strDocLocation: string;
  chrIsApproved: string|null;
  bitIsFromStatus?: boolean;
  intUID: number;
}
export interface IPRInvitationRoleMasterDataOutputModel {
  dE_Id: number;
  dED_Id: number;
  dED_Description: string;
  dED_Short_Description: string;
}

export interface IPRInvitationDisciplineMasterDataOutputModel {
  dE_Id: number;
  deD_Id: number;
  discipline: string;
  discipline_Short_Description: string;
}

export interface IPRInvitationLocationMasterDataOutputModel {
  dED_Id: number;
  dED_Description: string;
  dED_Short_Description: string;
  sort_By: string;
  dED_Name: string;
}

export interface IPRInvitationMembersMasterDataOutputModel {
  category: string;
  member_category_de_id: number;
  member_category_ded_id: number;
  member_id: number;
  psno: string;
  emp_name: string;
  role_de_id: number;
  role_ded_id: number;
  emp_role_desc: string;
  discipline_de_id: number;
  discipline_ded_id: number;
  discipline: string;
  mail_id: string;
}

export interface PeerRequestInput {
  intProjectID: number,
  intGroupID: number,
  strDocElements: string,
  dtScheduledOn: Date,
  tmScheduledFrom: Time,
  tmScheduledUpto: Time,
  chrVCRequired: string,
  strECDName: string,
  strMEPECDName: string,
  strDECDName: string,
  strProjectElements: string,
  strProjectLongDesc: string,
  strBuildingType: string,
  strScopeofWork: string,
  strBuiltupArea: string,
  strClient: string,
  strSiteArea: string,
  dtDateOfLOI: Date,
  mnyProjectValueInLakhs: DecimalPipe,
  mnyDesignFeeInLakhs: DecimalPipe,
  strProofConsultantName: string,
  strArchitecturalConsultantName: string,
  strStructuralConsultantName: string,
  strOtherConultantName: string,
  dtmSubmissionDateOfProject: Date,
  // tmSubmissionTimeOfProject: Time,
  chrIsEDMSAvailable: string,
  strScopeOfPeerReview: string,
  strPresenterDetails: string,
  strDocLocation: string,
  intUID: number,
  strDivisionName: string,
  strSegmentHead: string
}

export interface PeerRequestOutput{
  strDocNo: string,
  strOldDocNo: string,
  strErrorMsg: string
}

export interface PeerReqDocElementsInput {
  DE_ID: number,
  DED_ID: number,
  OTHERS_VALUE: string
}

export interface PeerReqPrjElementsInput {
  DE_ID: number,
  DED_ID: number
}

export interface PresenterDetailsInput {
  DE_ID: number,
  DED_ID: number,
  Presenter_Name: string,
  Presenter_Mail_Id: string,
  From_Time: string,
  Upto_Time: string,
  Remarks: string
}


export interface DocViewInput{
  strDocNumber : string,
  intUID: number
}

export interface DocViewOutput{
  docDetails: DocDetailsOutput,
  docFlowDetails: DocFlowOutput  
}

export interface DocPanelCRIOutpu{
  panelDetails: PanelDetailsOutput,
  cRIDetails: CRIDetailsOutput
}

export interface PanelDetailsOutput{
  slno: number,
  location_name: string,
  member_category: string,
  member_Name: string,
  member_PSNo: string,
  member_Role: string,
  member_Discipline: string,
  lprM_Comments_Submitted: string,
  lprM_Response_Submitted: string,
  lprM_Impact_Submitted: string,
  member_Type: string
}

export interface CRIDetailsOutput{
  discipline : string,
  commented_By : string,
  commented_On : Date,
  comment : string,
  comment_Category : string,
  is_Comments_Attachment_Available : string,
  is_Response_Received : string,
  response_Received_From : string,
  response_Received_On : Date,
  project_Design_Team_Response : string,
  response_Remarks : string,
  response_Entry_Done_By : string,
  response_Entry_Done_On : Date,
  disAgree_Reason : string,
  disAgree_Reason_Remarks : string,
  evidence_Remarks : string,
  evidence_Attachment_Available : string
}

export interface DocViewAllDetailsOutput{
  docDetails: DocDetailsOutput,
  docFlowDetails: DocFlowOutput,
  dpresenterDetails: DocPresenterDetails,
  panelDetails: PanelDetailsOutput,
  cRIDetails: CRIDetailsOutput
}

export interface DocDetailsOutput{
  doc_no						 : string 	  ,
  review_type					 : string 	  ,
  peer_review_refno			 : string 	  ,
  review_date			     	 : Date   ,
  review_from_time			 : Time   ,
  review_upto_time			 : Time   ,
  project_description			 : string 	  ,
  document_status				 : string 	  ,
  scope_of_review				 : string 	  ,
  services_included			 : string 	  ,
  required_documents     : string     ,
  type_of_structure      : string     ,
  stages_of_review			 : string 	  ,
  document_location			 : string 	  ,
  vc_required					 : string 	  ,
  ecd_for_project				 : string 	  ,
  mep_ecd_for_project			 : string 	  ,
  decd_for_project			 : string 	  ,
  project_name				 : string 	  ,
  project_code				 : string 	  ,
  building_type				 : string 	  ,
  client_name					 : string 	  ,
  project_value_in_lakhs		 : DecimalPipe 	  ,
  design_fee_in_lakhs			 : DecimalPipe 	  ,
  project_brief_desc			 : string 	  ,
  nature_of_project			 : string 	  ,
  contract_type				 : string 	  ,
  project_scope_of_work		 : string 	  ,
  built_up_area_in_sqm	     : string 	  ,
  plot_area_in_sqm			 : string 	  ,
  proof_consultant_name		 : string 	  ,
  architectural_consultant_name: string 	  ,
  structural_consultant_name	 : string 	  ,
  any_other_consultants		 : string 	  ,
  project_start_date			 : Date   ,
  project_end_date			 : Date   ,
  project_submission_date	     : Date   ,
  date_of_loi				     : Date   ,
  edms_available				 : string 	  ,
  scope_for_peer_review		 : string 	  ,
  created_by					 : string 	  ,
  created_on					 : Date	  ,
  approved_by					 : string 	  ,
  approved_on				     : Date   ,
  comments_status				 : string 	  ,
  response_status				 : string 	  ,
  impact_status				 : string 	  ,
  ds_code						 : number	  
}

export interface DocFlowOutput{
  document_Ref_No: number,
  slno: number,
  action_Desc: string,
  action_By: string,
  action_On: Date,
  remarks:string 
}

export interface DocPresenterDetails{
  dPRP_DE_Id: number,
  dPRP_DED_Id: number,
  discipline: string,
  dPRP_Presenter_Name: string,
  dPRP_Presenter_Mail_Id: string,
  hPRR_Presentation_From_Time: Time,
  hPRR_Presentation_To_Time: Time,
  dPRP_Additional_Remarks: Time
}

export interface IStatusInputModel{
  ProjectId: number,
  DocNum:  string ,
  DsCode: number,
  UID: number,
  Schdate: Date,
  Confirm: '1'
}

export interface IPeerReviewDedOutputModel{
  dE_Id: number,
  deD_Id: number,
  deD_Description:  string,
  deD_Short_Description: string,
  Sort_By?: number
}


export interface ICommentsListOutputModel{
  category: string|null,
  category_DED_Id: number|null,
  category_DE_Id: number|null,
  comment_By: string|null,
  comment_Id: number|null,
  comment_On: Date|null,
  disc_DED_Id: number|null,
  disc_DE_Id: number|null,
  disc_No: string|null,
  discipline: string|null,
  panel_Comments: string|null,
  potential_Comment: string|null,
  review_No: string,
  isAttachment?: string|null,
}

export interface ICommentsInputModel{
  Review_No: string,
  Save_Type: string,
  Panel_Comments?:  string ,
  Potential_Comment?:  string ,
  Disc_DE_Id: number,
  Disc_DED_Id: number,
  Category_DE_Id: number,
  Category_DED_Id: number,
  Attachment_Available:  string,
  UID: number,
  Comment_Id?: number,
  On_Behalf?: number
}

export interface IResponseListOutputModel{
  action_By: string,
  action_Date: Date,
  action_Remarks: string,
  category: string,
  comment_Id: number,
  dA_DED_Id: number,
  dA_DE_Id: number,
  disc_No: string,
  discipline: string,
  panel_Comments: string,
  potential_Comment: string,
  comments_Attachments : string,
  reason: string,
  reason_Remarks: string,
  responded_By: string,
  responded_On: Date,
  responder_Agreed: string,
  review_No: string,
  submitted_By: string,
  submitted_On: Date,
  evidence_Remarks: string,
  impact: string,
  isAttachment: string,
  comment_Status: string,
  response_Status: string,
  impactOpenClose : string,
  impactStatus : string,
  impactStatus_DE_ID : number,
  impactStatus_DED_ID : number,
  impactDateClosure : Date
}

export interface IResponseInputModel{
  Review_No: any,
  Comment_Id: number,
  Save_Type: string,
  IsAgreed: string,
  Response_Remarks?: string,
  Response_By?: string,
  Response_On?: string,
  ImpactOpenClose?: string,
  ImpactStatus_DE_ID?: number,
  ImpactStatus_DED_ID?: number,
  ImpactDateClosure?: string,
  Reason_DE_Id?: number,
  Reason_DED_Id?: number,
  Reason_Remarks?: string,
  UID: number
}

export interface PeerImpactOutputModel {

  impactDetails: IImpactListOutputModel[], 
  impactType: IPeerReviewDedOutputModel[],
}

export interface IImpactListOutputModel{
  action_By: string,
  action_Date: Date,
  action_Remarks: string,
  category: string,
  comment_Id: number,
  dS_Code: number,
  disc_No: string,
  discipline: string,
  evidence_Remarks: string,
  impact: string,
  panel_Comments: string,
  reason: string,
  responded_By: string,
  responded_On: Date,
  responder_Agreed: string,
  review_No: string,
  submitted_By: string,
  submitted_On: Date,
  isAttachment?: string,
  comment_Status?: string,
  response_Status?: string
}

export interface IImpactInputModel{
  strDocNumber: string,
  Save_Type: string,
  impactValues: string,
  commentRows: string,
  impactDetails: string,
  UID: number
}
